export default {
  holes : [],
  drills : [],
  zones : [],
  contracts : [],
  companies : [],
  projects : [],
  projectCodes : [],
  taskCategories: [],
  taskCategoriesPreferred: [],
  employeeTitles: [],
  stagingDailyReport: {
    selectedDate: null
  },
  instruments: [],
  coreBarrels: []
}
